import { render, staticRenderFns } from "./OpslaanDialog.vue?vue&type=template&id=7d2992a0"
import script from "./OpslaanDialog.vue?vue&type=script&lang=js"
export * from "./OpslaanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports